module.exports = __webpack_public_path__ + "static/media/5-8.fa333bf7.mp3";